import { Router, ActivatedRoute } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AgentActivityDetails,
  Address,
  Location,
  BathroomTypes,
  Participant
} from "@app/core/models/agent-activity-model";
import { AgentActivityListingService } from '@app/core/services/agent-activity.service';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { AppConfig } from '@app/core/Utilities/app-config.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { Binary } from '@angular/compiler';


@Component({
  selector: "app-agent-activity-detail",
  templateUrl: "./agent-activity-detail.component.html",
  styleUrls: ["./agent-activity-detail.component.scss"]
})
export class AgentActivityDetailComponent implements OnInit {
  public activityID: any;
  public agentActivityDetails: AgentActivityDetails;
  public isDataLoaded: boolean = false;
  public imageUrlArray: IImage[] = [];
  public fullscreen: boolean = false;
  public isLoggedIn: boolean = false;
  public agentId: number = 0;
  public showImageUploader: boolean = true;


  public validationErrorMessages: any = {
    'fileSize': 'File size must be less than 5MB !',
    'fileRequired': 'Please choose at least one file!'
  };
  public uploadImagesFormData: FormData;

  // Properties for Common Component For Uploading file
  public importSuccessMessages: any[] = [];
  public IsBusy = false;
  public isValidExtension = false;
  public errorFiles = '';
  public onUploadClicked: Subject<any> = new Subject();
  @ViewChild('fileUploder') public fileUploder: any;
  public fileUploaderSettings = {
    name: 'fileUploader1',
    url: '',
    disabled: false,
    styleClass: 'commonFileUploadStyle',
    allowMultiple: true,
    mode: 'advanced',
    accept: 'image/jpeg,image/png',
    //accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    maxFileSize: 5000000,
    auto: false,
    chooseLabel: 'Select Images',
    uploadLabel: 'Import',
    cancelLabel: 'Cancel',
    showUploadButton: false,
    showCancelButton: false,
    customUpload: true,
    fileLimit: 5,
    files: ''
  };
  uploadedFiles = [];
  fileUploaderData: any;
  fileExtension: any = ExcelFileExtension;
  fileUploaders: any[];

  constructor(
    private agentActivityListingService: AgentActivityListingService,
    private route: ActivatedRoute,
    private router: Router,
    private _appConfig: AppConfig,
    private _toaster: ToastrService,
    private _authservice: AuthenticationService
  ) {
    this.isLoggedIn = _authservice.isUserLoggedIn();

    if (this.isLoggedIn) {
      if (this._authservice.getUserInformation() === null) {
        this._authservice.getMemberDetails(this._authservice.getUserInformation()["ID"]).subscribe(
          (response: any) => {
            window.localStorage.setItem("agentBasicDetails", JSON.stringify(response));
            this.agentId = +this._authservice.getUserInformation()["ID"];
          }, (error: any) => { });
      }
    }
  }

  ngOnInit() {
    // Common file Uploader initiate
    this.fileUploaders = [{ fileUploaderSettings: this.fileUploaderSettings, uploadedFiles: this.uploadedFiles }];
    this.fileUploaderData = _.cloneDeep(this.fileUploaders);

    this.route.queryParams.subscribe(params => {
      this.activityID = this.route.snapshot.params.id;

      if (!this.activityID) {
        this.router.navigateByUrl("/");
      } else {
        this.getActivityDetails();
      }
    });
  }

  ngDoCheck() {
    if (this.fileUploder && this.fileUploder.fileUpload && this.fileUploder.fileUpload.files) {
      if (!this.fileUploder.fileUpload.files.length) {
        this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
      }
    }
  }

  getActivityDetails() {
    this.isDataLoaded = false;
    this.agentActivityListingService
      .getAgentActivityDetails(this.activityID)
      .subscribe(
        (activityDetails: any) => {

          this.agentActivityDetails = new AgentActivityDetails();
          this.agentActivityDetails.id = activityDetails.id;

          if (!activityDetails.IsCustom) {

            window["lh"]('submit', 'DETAIL_PAGE_VIEWED', { lkey: activityDetails.id });
          }

          this.imageUrlArray = [];
          if (activityDetails.Photos) {
            if (activityDetails.Photos.Photo.length) {
              activityDetails.Photos.Photo.forEach(element => {
                this.imageUrlArray.push(element.MediaURL)
              });
            } else {
              this.agentActivityDetails.MediaURL = '';
            }
          } else {
            this.agentActivityDetails.MediaURL = '';
          }

          this.agentActivityDetails.Address = new Address();
          this.agentActivityDetails.Address.FullStreetAddress =
            this.getValidateValue(activityDetails.Address, 'FullStreetAddress');
          // activityDetails.Offices.Office.Address["FullStreetAddress"];
          this.agentActivityDetails.ListingStatus = this.getValidateValue(activityDetails, 'ListingStatus');
          // activityDetails.ListingStatus;
          this.agentActivityDetails.Address.City =
            this.getValidateValue(activityDetails.Address, 'City');
          // activityDetails.Offices.Office.Address["City"];
          this.agentActivityDetails.Address.State =
            this.getValidateValue(activityDetails.Address, 'StateOrProvince');
          this.agentActivityDetails.Address.Country =
            this.getValidateValue(activityDetails.Address, 'Country');
          // activityDetails.Offices.Office.Address["Country"];
          this.agentActivityDetails.Address.PostalCode =
            this.getValidateValue(activityDetails.Address, 'PostalCode');
          this.agentActivityDetails.Address.UnitNumber = this.getValidateValue(activityDetails.Address, 'UnitNumber') != null ? this.getValidateValue(activityDetails.Address, 'UnitNumber') + ', ' : '';
          this.agentActivityDetails.ListPrice = this.getValidateValue(activityDetails, 'ListPrice.#text'); // activityDetails.ListPrice["#text"];
          this.agentActivityDetails.ListPrice = this.agentActivityDetails.ListPrice.length > 1 ? this.agentActivityDetails.ListPrice : '';

          this.agentActivityDetails.Bedrooms = activityDetails.Bedrooms;
          this.agentActivityDetails.Bathrooms = activityDetails.Bathrooms;
          this.agentActivityDetails.ListingDescription =
            this.getValidateValue(activityDetails, 'ListingDescription');
          this.agentActivityDetails.ListingKey = this.getValidateValue(activityDetails, 'ListingKey');
          this.agentActivityDetails.Participant = new Participant();
          console.log()
          this.agentActivityDetails.Participant.FirstName = activityDetails.ListingParticipants != null ? this.getValidateValue(activityDetails.ListingParticipants.Participant, 'FirstName') : '';

          this.agentActivityDetails.Participant.LastName = activityDetails.ListingParticipants != null ? this.getValidateValue(activityDetails.ListingParticipants.Participant, 'LastName') : '';

          // PROPERTY DETAILS : start

          // Overview: start
          this.agentActivityDetails.PropertyType = this.getValidateValue(activityDetails, 'PropertyType.@otherDescription');
          this.agentActivityDetails.PropertySubType = this.getValidateValue(activityDetails, 'PropertySubType.@otherDescription');
          // activityDetails.PropertyType["@otherDescription"];
          this.agentActivityDetails.Style =
            this.getValidateValue(activityDetails.DetailedCharacteristics, 'ArchitectureStyle.#text');
          // activityDetails.DetailedCharacteristics.ArchitectureStyle["#text"];
          this.agentActivityDetails.MlsNumber = activityDetails.MlsNumber;

          if (activityDetails.ListingKey) {
            this.agentActivityDetails.ListingID = activityDetails.ListingKey.split("-")[activityDetails.ListingKey.split("-").length - 1];
          } else {
            this.agentActivityDetails.ListingID = this.activityID.split("-")[this.activityID.split('-').length - 1];
          }

          this.agentActivityDetails.DaysOnMarket =
            this.getValidateValue(activityDetails, 'MarketingInformation.commons_VOWConsumerComment');
          // activityDetails.MarketingInformation.commons_VOWConsumerComment;
          this.agentActivityDetails.BrokerName =
            this.getValidateValue(activityDetails, 'Brokerage.Name');
          // activityDetails.Brokerage.Name;
          this.agentActivityDetails.BrokerOffice =
            this.getValidateValue(activityDetails, 'Brokerage.Phone');
          // activityDetails.Brokerage.Phone;
          this.agentActivityDetails.ListingURL = activityDetails.ListingURL;
          this.agentActivityDetails.LivingArea = activityDetails.LivingArea;
          // Overview: end

          // Details: start
          this.agentActivityDetails.BathroomTypes = new BathroomTypes();
          this.agentActivityDetails.BathroomTypes.FullBathrooms =
            activityDetails.FullBathrooms;
          this.agentActivityDetails.BathroomTypes.ThreeQuarterBathrooms =
            activityDetails.ThreeQuarterBathrooms;
          this.agentActivityDetails.BathroomTypes.HalfBathrooms =
            activityDetails.HalfBathrooms;
          this.agentActivityDetails.BathroomTypes.OneQuarterBathrooms =
            activityDetails.OneQuarterBathrooms;
          this.agentActivityDetails.BathroomTypes.PartialBathrooms =
            activityDetails.PartialBathrooms;
          this.agentActivityDetails.LivingAreaSize = null;
          this.agentActivityDetails.ParkingInformation = null;
          this.agentActivityDetails.Amenities = null;
          // Details: end

          // Construction Details : start
          this.agentActivityDetails.ArchitecturalStyle =
            this.getValidateValue(activityDetails.DetailedCharacteristics, 'ArchitectureStyle.#text');
          // activityDetails.DetailedCharacteristics.ArchitectureStyle["#text"];
          this.agentActivityDetails.RoofDescription =
            this.getValidateValue(activityDetails.DetailedCharacteristics, 'RoofTypes.RoofType');
          // activityDetails.DetailedCharacteristics.RoofTypes.RoofType;
          // Construction Details : end

          activityDetails.Location ?
            this.agentActivityDetails.Neighborhoods =
            this.getValidateValue(activityDetails.Location.Neighborhoods, 'Neighborhood.Name') : '';
          // activityDetails.Location.Neighborhoods.Neighborhood.Name;

          this.agentActivityDetails.Location = new Location();
          this.agentActivityDetails.Location.Latitude =
            this.getValidateValue(activityDetails.Location, 'Latitude');
          // activityDetails.Location.Latitude;
          this.agentActivityDetails.Location.Longitude =
            this.getValidateValue(activityDetails.Location, 'Longitude');
          // activityDetails.Location.Longitude;
          this.agentActivityDetails.Location.Directions =
            this.getValidateValue(activityDetails.Location, 'Directions');
          // activityDetails.Location.Directions;

          this.agentActivityDetails.MapLocation =
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2779.913750547096!2d" +
            this.agentActivityDetails.Location.Longitude +
            "!3d" +
            this.agentActivityDetails.Location.Latitude +
            "!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDQ5JzU4LjgiTiA4OMKwMDMnMzEuMyJX!5e0!3m2!1sen!2sin!4v1556789445864!5m2!1sen!2sin";

          this.agentActivityDetails.Disclaimer =
            this.getValidateValue(activityDetails.Disclaimer, '#text');

          this.isDataLoaded = true;

          setTimeout(() => {
            document.getElementById("ifrm") ? document.getElementById("ifrm").setAttribute("src", this.agentActivityDetails.MapLocation) : '';
          }, 1500);


          this.isLoggedIn = this._authservice.isUserLoggedIn();
          if (this.isLoggedIn) {
            this.showImageUploader = this._authservice.getUserInformation()["ID"] == activityDetails.agentId;
          } else {
            this.showImageUploader = false;
          }

        },
        (error: any) => {
          this._toaster.error('Something went wrong, Please try after sometime!');
          this.router.navigateByUrl('/');
        }
      );
  }

  // Validate The Perticular Properties from object (up to 2 hierarchy level)
  getValidateValue(objectValue: any, valueFor: string) {
    var returnValue = '';

    if (objectValue) {
      if (!valueFor.includes('.')) {
        if (objectValue.hasOwnProperty(valueFor)) {
          returnValue = objectValue[valueFor];
        }
      } else {

        let element1 = valueFor.split('.')[0];
        let element2 = valueFor.split('.')[1];

        if (objectValue.hasOwnProperty(element1)) {

          if (objectValue[element1]) {
            if (objectValue[element1].hasOwnProperty(element2)) {
              returnValue = objectValue[element1][element2];
            }
          }
        }
      }
    }

    return returnValue;
  }

  // Common File Uploader Methods
  filesUpload($event) {
    if (!$event)
      return
    if (!$event.length)
      return

    this.uploadImagesFormData = new FormData();
    this.agentId = this.agentId === 0 ? 5 : this.agentId;
    // // this.uploadImagesFormData.append('AgentID', this.agentId.toString());
    // this.uploadImagesFormData.append('ListingID', this.activityID); // this.activityID.toString()

    var i = 0;
    var binaryArr = []
    // var binary = new Binary[5];
    for (let file of $event) {
      binaryArr.push(file)
      this.uploadImagesFormData.append("file[]", file, file.name);
      i++;
    }
    //this.uploadImagesFormData.append("file",  JSON.stringify(binaryArr));

    this.agentActivityListingService.uploadImage(this.activityID, this.uploadImagesFormData).subscribe(
      (response: any) => {
        this._toaster.success('Images Uploaded Successfully.');
        this.getActivityDetails();
      },
      (error: any) => {
        this._toaster.error('Something went wrong! Please try after sometime.');
        // this.isLoggedIn = false;
        // this._toaster.error('Please Login again for upload images!');

      }
    )
  }

  onFilesSelect($event) {

    if ((this.fileUploder && this.fileUploder.fileUpload.files.length > 0)) {
      if (!!this.fileUploder && this.fileUploder.fileUpload.files.length > this.fileUploaders[0].fileUploaderSettings.fileLimit) {
        this._toaster.error('You can upload maximum ' + this.fileUploaders[0].fileUploaderSettings.fileLimit + ' file', this._appConfig.toasterError);
        this.fileUploder.fileUpload.remove();
        this.fileUploder.fileUpload.files = [];
        return;
      }
    }

    if (this.fileUploder.fileUpload.files.length) {
      this.fileUploaderData[0].fileUploaderSettings.showUploadButton = true;
    }
  }

  UploadFile(res: any) {
    if (this.fileUploder && this.fileUploder.fileUpload.files.length > 0) {
      this.onUploadClicked.next(res.resultId);
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 GB'
    if (isNaN(parseInt(bytes))) return bytes
    if (typeof bytes === 'string') bytes = parseInt(bytes)
    if (bytes === 0) return '0';
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }

  removeFile(fileName: any) {

    let index = 0;
    this.fileUploder.fileUpload.files.forEach(element => {
      if (element.name == fileName) {
        this.fileUploder.fileUpload.files.splice(index, 1);
      }

      index++;
    });

    if (!this.fileUploder.fileUpload.files.length)
      this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
    // this.fileUploder.fileUpload.files = [];

  }
}

export class ImportFileRequestModal {
  AgentID: number;
  File: any;
  FileName: string;
}
export const ExcelFileExtension = [
  'jpg',
  'jpeg',
  'png',
  'gif'
]


export interface IImage {
  url: string | null;
  href?: string;
  clickAction?: Function;
  caption?: string;
  title?: string;
  backgroundSize?: string;
  backgroundPosition?: string;
  backgroundRepeat?: string;
}
